const IMAGE_RESOLUTION = 'iphone';

export const getGPImageUrl = (url: string, defaultUrl: string): string => {
    if (!url) {
        return defaultUrl;
    }

    const splited = url.split('.');

    if (splited[splited.length - 1] === 'png') {
        return url;
    } else {
        return `${url}${IMAGE_RESOLUTION}.png`;
    }
};
